(function () {
  'use strict';

  function initHeroLoop(root) {
    if (!root || root.dataset.agCfHeroLoopBound === 'true') return;

    var track = root.querySelector('[data-ag-cf-slider-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ag-cf-slide]'));
    var previous = root.querySelector('[data-ag-cf-slider-prev]');
    var next = root.querySelector('[data-ag-cf-slider-next]');
    var progress = root.querySelector('[data-ag-cf-slider-progress]');
    if (!track || slides.length < 2) return;

    root.dataset.agCfHeroLoopBound = 'true';

    var total = slides.length;
    // Keep one complete slide set on each side so loop depth follows the actual gallery size.
    var cloneCount = total;
    var leadingClones = [];
    var trailingClones = [];
    var leadingCloneCount;
    var allSlides;
    var normalizeTimer;
    var touchStartX = 0;
    var touchActive = false;
    var touchEndPending = false;
    var controlTransitionPending = false;
    var normalizationEpoch = 0;

    function prepareClone(clone) {
      clone.removeAttribute('data-ag-cf-slide');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ag-cf-hero-clone', 'true');
      clone.classList.add('ag-cf-v3__hero-slide--clone');
    }

    for (var cloneIndex = 0; cloneIndex < cloneCount; cloneIndex += 1) {
      var leadingClone = slides[total - cloneCount + cloneIndex].cloneNode(true);
      var trailingClone = slides[cloneIndex].cloneNode(true);
      prepareClone(leadingClone);
      prepareClone(trailingClone);
      leadingClones.push(leadingClone);
      trailingClones.push(trailingClone);
    }

    for (var leadingIndex = leadingClones.length - 1; leadingIndex >= 0; leadingIndex -= 1) {
      track.insertBefore(leadingClones[leadingIndex], track.firstChild);
    }
    trailingClones.forEach(function (clone) {
      track.appendChild(clone);
    });

    leadingCloneCount = leadingClones.length;
    allSlides = leadingClones.concat(slides, trailingClones);

    function getSlideOffset(index) {
      return allSlides[index].offsetLeft;
    }

    function getNearestIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      allSlides.forEach(function (slide, index) {
        var distance = Math.abs(track.scrollLeft - slide.offsetLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function getRealIndex(index) {
      var realIndex = (index - leadingCloneCount) % total;
      return realIndex < 0 ? realIndex + total : realIndex;
    }

    function setProgress(index) {
      if (!progress) return;
      progress.textContent = String(getRealIndex(index) + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    }

    function cancelNormalization() {
      normalizationEpoch += 1;
      window.clearTimeout(normalizeTimer);
      normalizeTimer = null;
    }

    function normalizeBoundary() {
      if (touchActive) return;

      cancelNormalization();

      var index = getNearestIndex();
      var normalizedIndex = index;

      if (index < leadingCloneCount) normalizedIndex = index + total;
      if (index >= leadingCloneCount + total) normalizedIndex = index - total;

      if (normalizedIndex !== index) {
        var previousScrollSnapType = track.style.scrollSnapType;
        var previousScrollBehavior = track.style.scrollBehavior;

        // Keep the clone-to-real correction out of the browser's snap/scroll animation.
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = getSlideOffset(normalizedIndex);

        window.requestAnimationFrame(function () {
          track.style.scrollSnapType = previousScrollSnapType;
          track.style.scrollBehavior = previousScrollBehavior;
        });
      }

      touchEndPending = false;
      controlTransitionPending = false;
      setProgress(normalizedIndex);
    }

    function scheduleNormalization(delay) {
      if (touchActive) return;

      window.clearTimeout(normalizeTimer);
      var epoch = normalizationEpoch + 1;
      normalizationEpoch = epoch;
      normalizeTimer = window.setTimeout(function () {
        if (epoch !== normalizationEpoch || touchActive) return;
        normalizeBoundary();
      }, delay);
    }

    function goToAdjacent(direction) {
      cancelNormalization();
      touchEndPending = false;
      controlTransitionPending = true;

      var currentIndex = getNearestIndex();
      var targetIndex = currentIndex + direction;

      if (targetIndex < 0 || targetIndex >= allSlides.length) {
        normalizeBoundary();
        currentIndex = getNearestIndex();
        targetIndex = currentIndex + direction;
      }

      setProgress(targetIndex);
      track.scrollTo({ left: getSlideOffset(targetIndex), behavior: 'smooth' });
      scheduleNormalization(900);
    }

    function goPrevious() {
      goToAdjacent(-1);
    }

    function goNext() {
      goToAdjacent(1);
    }

    function stopCommonControl(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    if (previous) {
      previous.addEventListener('click', function (event) {
        stopCommonControl(event);
        goPrevious();
      }, true);
    }

    if (next) {
      next.addEventListener('click', function (event) {
        stopCommonControl(event);
        goNext();
      }, true);
    }

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        stopCommonControl(event);
        goPrevious();
      }
      if (event.key === 'ArrowRight') {
        stopCommonControl(event);
        goNext();
      }
    }, true);

    track.addEventListener('scroll', function () {
      setProgress(getNearestIndex());
    }, { passive: true });

    track.addEventListener('scrollend', function () {
      if (touchActive) return;
      if (touchEndPending || controlTransitionPending) scheduleNormalization(80);
    }, { passive: true });

    track.addEventListener('touchstart', function (event) {
      var touch = event.touches[0];
      if (!touch) return;

      cancelNormalization();
      touchEndPending = false;
      controlTransitionPending = false;
      touchStartX = touch.clientX;
      touchActive = true;
    }, { passive: true });

    track.addEventListener('touchend', function (event) {
      if (!touchActive) return;
      touchActive = false;

      var touch = event.changedTouches[0];
      if (!touch || Math.abs(touch.clientX - touchStartX) < 24) {
        touchEndPending = false;
        return;
      }

      touchEndPending = true;
      scheduleNormalization(650);
    }, { passive: true });

    track.addEventListener('touchcancel', function () {
      touchActive = false;
      touchEndPending = true;
      scheduleNormalization(650);
    }, { passive: true });

    track.scrollLeft = getSlideOffset(leadingCloneCount);
    setProgress(leadingCloneCount);
  }

  function init() {
    document.querySelectorAll('[data-ag-cf-hero-slider]').forEach(initHeroLoop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
